
/**
 * @roxi/routify 2.18.12
 * File generated Thu Sep 18 2025 19:44:28 GMT+0000 (Coordinated Universal Time)
 */

export const __version = "2.18.12"
export const __timestamp = "2025-09-18T19:44:28.885Z"

//buildRoutes
import { buildClientTree } from "@roxi/routify/runtime/buildRoutes"

//imports


//options
export const options = {}

//tree
export const _tree = {
  "root": true,
  "children": [
    {
      "isFallback": true,
      "path": "/_fallback",
      "component": () => import('../src/modules/_fallback.svelte').then(m => m.default)
    },
    {
      "isPage": true,
      "path": "/shared-example",
      "id": "_sharedExample",
      "component": () => import('../src/modules/shared-example.svelte').then(m => m.default)
    },
    {
      "isIndex": true,
      "isPage": true,
      "ownMeta": {
        "index": 1
      },
      "meta": {
        "index": 1,
        "recursive": true,
        "preload": false,
        "prerender": true
      },
      "path": "/index",
      "id": "_index",
      "component": () => import('../src/modules/index.svelte').then(m => m.default)
    },
    {
      "isPage": true,
      "ownMeta": {
        "index": 2
      },
      "meta": {
        "index": 2,
        "recursive": true,
        "preload": false,
        "prerender": true
      },
      "path": "/work",
      "id": "_work",
      "component": () => import('../src/modules/work.svelte').then(m => m.default)
    },
    {
      "isPage": true,
      "ownMeta": {
        "index": 3
      },
      "meta": {
        "index": 3,
        "recursive": true,
        "preload": false,
        "prerender": true
      },
      "path": "/about",
      "id": "_about",
      "component": () => import('../src/modules/about.svelte').then(m => m.default)
    }
  ],
  "isLayout": true,
  "path": "/",
  "id": "__layout",
  "component": () => import('../src/modules/_layout.svelte').then(m => m.default)
}


export const {tree, routes} = buildClientTree(_tree)

